module.exports = __webpack_public_path__ + "img/icon_4.fe5f8e98.png";